const IncorrectAnswersBelievable = {
    OBVIOUSLY_WRONG: 'Nyilvánvalóan helytelenek a válaszok',
    SEEM_CORRECT: 'Hihetőek a válaszok',
};

export default IncorrectAnswersBelievable;